var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RLayoutBox"},[_c('h2',[_vm._v("报废机动车回收拆解业务全场景解决方案")]),_c('img',{attrs:{"src":require("../assets/img/lct.png"),"alt":"","width":"80%"}})])
}]

export { render, staticRenderFns }